import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tool, useAppDate } from '../context/AppContext';
import { useAdminLogin } from '../hooks/useAdminLogin';


const LoginScreen: React.FC = () => {
  const { jointToChatRoom,role,tool } = useAppDate();
  const { adminLogin, loading: loginLoading, error: loginError } = useAdminLogin();

  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const res = await adminLogin(email, password);
    setLoading(false);
    if (res.success) {
      jointToChatRoom({ userEmail: email, role: 'csi', tool: Tool.ETF });
      navigate('/chat');
    } else {
      setError('Invalid email or password');
    }
  };

  const handleHome =  () => {    
    if (role !== 'csi') {
      navigate(`/?tool=${encodeURIComponent(tool)}`);
    } else {      
      navigate('/');
    }
  }

  

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <form
        className="bg-white p-8 rounded shadow-md w-full max-w-sm"
        onSubmit={handleLogin}
      >
        <h1 className="text-2xl font-bold mb-4">Login</h1>
        <input
          type="email"
          className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:ring"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          className="w-full border rounded px-3 py-2 mb-4 focus:outline-none focus:ring"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
        {error && <div className="text-red-500 text-sm mb-2">{error}</div>}
        <div className="flex flex-row gap-4">
          <button
            type="button"
            className="flex-1 bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400 transition disabled:opacity-50"
            disabled={loading}
            onClick={handleHome}
          >
            Home
          </button>
          <button
            type="submit"
            className="flex-1 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition disabled:opacity-50"
            disabled={loading}
          >
            {loading || loginLoading ? 'Logging in...' : 'Login'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default LoginScreen; 

